import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { useState } from 'react';
import { putAmbassadorAction } from 'src/redux/actions/ambassadorActions';
import palette from 'src/styles/palette';

const EditAmbassadorMessageDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.editAmbassadorMessage]) {
        return state.dialog[DIALOGS.editAmbassadorMessage];
      }
      return { opened: false, payload: {} };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');
  const ambassadors = useSelector((state: Store) => state.ambassadors);

  const { selected, fundraisingId } = payload ?? { selected: [] as string[], fundraisingId: 0 };

  const [message, setMessage] = useState('');

  const handleCancel = () => {
    setMessage('');
    dispatch(closeDialog({ dialog: DIALOGS.editAmbassadorMessage }));
  };

  const handleOk = () => {
    const targets = ambassadors.filter(
      (ambassador) => selected.includes(ambassador.id?.toString() ?? ''),
    );

    targets.forEach((ambassador) => {
      dispatch(putAmbassadorAction({
        id: ambassador.id,
        event_id: fundraisingId,
        contact_id: ambassador.contact_id,
        notify_by_email: ambassador.notify_by_email,
        notify_by_sms: ambassador.notify_by_sms,
        invitation_sms_sent: ambassador.invitation_sms_sent,
        invitation_email_sent: ambassador.invitation_email_sent,
        name: ambassador.name,
        goal: ambassador.goal,
        slug: ambassador.slug,
        message,
        video_link: ambassador.video_link,
      }));
    });

    setMessage('');
    dispatch(closeDialog({ dialog: DIALOGS.editAmbassadorMessage }));
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="edit-ambassador-message"
      open={opened}>
      <DialogTitle id="edit-ambassador-message">
        <span style={{ color: palette.primary.main }}>
          {t(lang, 'menus.edit_ambassador_message')}
        </span>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Message"
          multiline
          minRows={4}
          maxRows={8}
          fullWidth
          variant="outlined"
          value={message}
          onChange={(e) => setMessage(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.cancel')}
        </Button>
        <Button onClick={handleOk} color="primary" disabled={!message.trim()}>
          {t(lang, 'misc.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditAmbassadorMessageDialog;
